module.exports = __webpack_public_path__ + "22_iv.jpg?e38bf3088d4e4196ac48b08267d2ff06";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/22_iv.jpg
// module id = 185
// module chunks = 0